import { WebGLRenderer, LinearSRGBColorSpace } from "three";

function getWithConf(isHighPerf, antialiasingMode) {
  const perf = isHighPerf ? "high-performance" : "default";
  const renderer = new WebGLRenderer({
    canvas: document.createElement("canvas"),
    alpha: true,
    antialias: antialiasingMode,
    depth: true,
    precision: "mediump",
    stencil: false,
    preserveDrawingBuffer: false,
    logarithmicDepthBuffer: false,
    powerPreference: perf,
  });
  renderer.localClippingEnabled = true;
  renderer.outputColorSpace = LinearSRGBColorSpace;
  renderer.setClearAlpha(1);
  renderer.alpha = true;
  renderer.sortObjects = true;
  renderer.gammaOutput = 2.2;
  renderer.setScissorTest(true);
  renderer.setClearColor(0x000000, 0);
  return renderer;
}

function getRenderer({ antialiasingMode }) {
  try {
    return getWithConf(true, antialiasingMode);
  } catch (e) {
    try {
      return getWithConf(false, antialiasingMode);
    } catch (err) {
      throw new Error("webgl-create-renderer");
    }
  }
}

export default getRenderer;
